// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_v-OYs","box":"index_box_IoF-Q","footer":"index_footer_0lw9r"};